// Car version of the laptop text customiser JS ("Customise Your Own Text | Car Patch").
// White text is previewed on a rear windshield, Black text on a white car's boot; each background
// carries its real-world width (data-scene-width-in) so the text reads at its true relative size.
document.querySelectorAll('[data-custom-car-preview]').forEach(function (preview) {
  var root = preview.closest('.custom-personalization');
  if (!root) return;

  var textInput = root.querySelector('[data-custom-text-input]');
  var fontSelect = root.querySelector('[data-custom-font-select]');
  var colorSelect = root.querySelector('[data-custom-color-select]');
  var previewLabel = root.querySelector('[data-custom-text-preview-label]');
  var bgGlass = preview.querySelector('[data-car-bg-glass]');
  var bgBody = preview.querySelector('[data-car-bg-body]');
  var customSizeInput = root.querySelector('[data-custom-size-input]');

  if (!textInput || !fontSelect || !colorSelect || !previewLabel || !bgGlass || !bgBody) return;

  var PROBE_PX = 100;

  function parseSizeFromLabelFor(radio) {
    if (!radio || !radio.id) return null;
    var label = root.querySelector('label[for="' + radio.id + '"]');
    if (!label) return null;
    var match = label.textContent.match(/(\d+(\.\d+)?)/);
    return match ? parseFloat(match[1]) : null;
  }

  function getSelectedSizeIn() {
    if (customSizeInput && customSizeInput.value) {
      var custom = parseFloat(customSizeInput.value);
      if (!isNaN(custom) && custom > 0) return custom;
    }
    var radios = root.querySelectorAll('[data-primary-size-radio]');
    var checked = root.querySelector('[data-primary-size-radio]:checked');
    var fromChecked = parseSizeFromLabelFor(checked);
    if (fromChecked) return fromChecked;
    // Nothing picked yet -- fall back to the smallest listed size so the
    // preview still looks proportionate before the customer touches it.
    var fromFirst = parseSizeFromLabelFor(radios[0]);
    return fromFirst || 3;
  }

  function fitNameWidth() {
    var activeBg = bgGlass.hidden ? bgBody : bgGlass;
    var sceneWidthIn = parseFloat(activeBg.getAttribute('data-scene-width-in')) || 34;
    var fraction = Math.max(0.05, Math.min(1, getSelectedSizeIn() / sceneWidthIn));
    var containerWidth = preview.clientWidth || 1;
    var targetWidthPx = containerWidth * fraction;

    previewLabel.style.fontSize = PROBE_PX + 'px';
    var measuredWidth = previewLabel.getBoundingClientRect().width || 1;
    var finalSize = PROBE_PX * (targetWidthPx / measuredWidth);
    finalSize = Math.max(8, Math.min(containerWidth * 0.35, finalSize));
    previewLabel.style.fontSize = finalSize + 'px';
  }

  function update() {
    var text = textInput.value.trim();
    var fontOption = fontSelect.options[fontSelect.selectedIndex];
    var fontFamily = fontOption ? fontOption.getAttribute('data-font-family') : null;
    var color = colorSelect.value;

    previewLabel.textContent = text || 'Your Text';
    preview.toggleAttribute('data-empty', !text);
    previewLabel.style.fontFamily = fontFamily ? "'" + fontFamily + "'" : '';

    // White on the windshield is the product's cover look, so it is the default until Black is picked.
    var isBlack = color === 'Black';
    previewLabel.style.color = isBlack ? '#111111' : '#ffffff';
    bgGlass.hidden = isBlack;
    bgBody.hidden = !isBlack;
    preview.setAttribute('data-car-color', isBlack ? 'Black' : 'White');

    fitNameWidth();
  }

  textInput.addEventListener('input', update);
  fontSelect.addEventListener('change', update);
  colorSelect.addEventListener('change', update);
  root.addEventListener('change', function (event) {
    if (event.target && event.target.matches('[data-primary-size-radio]')) update();
  });
  if (customSizeInput) customSizeInput.addEventListener('input', update);

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(fitNameWidth, 100);
  });

  update();

  root.customPersonalizationReset = function () {
    textInput.value = '';
    fontSelect.selectedIndex = 0;
    colorSelect.selectedIndex = 0;
    update();
  };

  root.customPersonalizationPrefill = function (data) {
    if (data.text) textInput.value = data.text;
    if (data.font) fontSelect.value = data.font;
    if (data.color) colorSelect.value = data.color;
    update();
  };
});
